@if (quote() !== undefined) {
  <div class="td-wb-todays-change"
       [class.td-wb-green]="hasDollarChangedUp()"
       [class.td-wb-red]="hasDollarChangedDown()">
    <!-- hasDollarChanged => Show content if dollar value changed -->
    @if (hasDollarChanged()) {
      @if (isIssueTypeIndex()) {
        <span>
          <span [innerHTML]="quote().dollarChange | tdWbNumber: { prependSign: true, color: true }"></span>
        </span>
      } @else {
        @if (!isLastPriceOneOrMore()) {
          <span [innerHTML]="quote().dollarChange | tdWbCurrency: { prependSign: true, color: true, format: 'c4-2' }">
          </span>
        }
        @if (isLastPriceOneOrMore()) {
          <span [innerHTML]="quote().dollarChange | tdWbCurrency: { prependSign: true, color: true, format: 'c2' }">
          </span>
        }
      }
      <span class="td-wb-todays-change__all-types">
        (<span [innerHTML]="quote().percentageChange | tdWbPercent: { prependSign: false, color: true }"></span>)
      </span>
    } @else {
      @if (!quote().sessionIsActive) {
        <span>
          <span [textContent]="null | tdWbNumber: { nullPlaceholder: '-' }"></span>
        </span>
      }
      @if (isIssueTypeIndex() && quote().sessionIsActive) {
        <span>
          <span [innerText]="0.00 | tdWbNumber : { format: 'n2'}"></span>
          (<span [innerText]="0.00 | tdWbPercent : { format: 'n2' }"></span>)
        </span>
      }
      @if (!isIssueTypeIndex() && quote().sessionIsActive) {
        <span>
          <span [innerText]="0.00 | tdWbCurrency : { format: 'c2' }"></span>
          (<span [innerText]="0.00 | tdWbPercent"></span>)
        </span>
      }
    }
  </div>
}
